/** Parse API date strings without UTC day-shift (YYYY-MM-DD → local midnight). */
export function parseAppDate(value) {
  if (value == null || value === "") return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const str = String(value).trim();
  const dateOnly = str.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (dateOnly) {
    return new Date(
      Number(dateOnly[1]),
      Number(dateOnly[2]) - 1,
      Number(dateOnly[3]),
    );
  }

  const datePart = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (datePart && !/T\d{2}:\d{2}/.test(str)) {
    return new Date(
      Number(datePart[1]),
      Number(datePart[2]) - 1,
      Number(datePart[3]),
    );
  }

  const date = new Date(str);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function todayLocalDateString() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function formatAppDate(value) {
  const date = parseAppDate(value);
  if (!date) return value ? String(value) : "-";
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function formatAppDateTime(value) {
  const date = parseAppDate(value);
  if (!date) return value ? String(value) : "-";

  const str = String(value).trim();
  const isDateOnly =
    /^\d{4}-\d{2}-\d{2}$/.test(str) ||
    /^\d{4}-\d{2}-\d{2}T00:00:00/.test(str);

  if (isDateOnly) {
    return formatAppDate(value);
  }

  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}
